/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'antd';
import { formattedAccountList } from 'components/shared/AccountDropdown';
import { formattedContactAccountList } from 'components/shared/ContactDropdown';
import useDynamicForm from 'hooks/useDynamicForm';
import useOssixProviders from 'hooks/useOssixProviders';
import { IOssixProvider } from 'interfaces/otherInterface/dynamicInput';
import { IAccountInfo } from 'interfaces/queries/account';
import BetweenOwnAccount from 'pages/bank/Transfer/BetweenOwnAccount';
import { getUserContact } from 'queries/ossix/user/userData';
import { userAccountNumbers } from 'queries/ossix/wallet/requestWallet';
import { useEffect, useState } from 'react';
import { ActionType, TargetType } from 'types/generalType';

interface BetweenOwnAccountContainerProps {
  isDrawerOpen: any;
  handleCloseOpenDrawer: () => void;
}

const BetweenOwnAccountContainer: React.FC<
  BetweenOwnAccountContainerProps
> = ({ isDrawerOpen, handleCloseOpenDrawer }) => {
  const [form] = Form.useForm();
  const [step, setStep] = useState(1);
  const [accountNumber, setAccountNumber] = useState();
  const [contactAccount, setContactAccount] = useState<any>();
  const [selectedProvider, setSelectedProvider] = useState<
    IOssixProvider | undefined
  >();
  const [secondAccountNumber, setSecondAccountNumber] =
    useState<any>(null);
  const { loadUserAccountNumbers, accountNumbers } =
    userAccountNumbers();
  const [displaySelectContact, setDisplaySelectContact] =
    useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] =
    useState<any>();
  const accountNumbersInfo: IAccountInfo[] = accountNumbers;
  const selectAccountNumber = formattedAccountList(
    accountNumbersInfo,
  );

  const onHandleDisplaySelectContact = () =>
    setDisplaySelectContact(true);

  const onHandleCloseSelectContact = () => {
    setDisplaySelectContact(false);
    setSelectedBeneficiary(undefined);
    setContactAccount({
      value: '',
      label: '',
    });
  };

  const {
    contextHolder,
    onHandleValueChange,
    loadTransferConfirmation,
    transferConfirmationData,
    onPINValuesChange,
    onHandleBankConfirmTransfer,
    loadSendFundsToGateway,
    openPrintTransaction,
    sendFundsToGatewayData,
    onHandleClosePrintPage,
    onHandleBankGatewayTransferConfirmation,
    setFormData,
    formData,
    userData,
    onHandleSaveContact,
    showVerificationModal,
    verificationData,
    handleVerificationComplete,
    handleVerificationCancel,
  } = useDynamicForm({
    form: form,
    accountNumber: accountNumber,
    nextStep: setStep,
    accountNumberName: selectAccountNumber?.[0]?.text,
    selectedBeneficiary: selectedBeneficiary,
    provider: selectedProvider,
  });

  const { isLoadingContacts, userContactData } = getUserContact({
    CountryCode: userData?.[0]?.OperationCountry,
  });

  const recipientAccountNumber = formattedContactAccountList(
    userContactData &&
      userContactData?.filter(
        (item: { Category: TargetType }) =>
          item?.Category === TargetType.Bank,
      ),
  );

  const onPrevious = () => setStep((prevStep) => prevStep - 1);

  const { providers, loadingProviders } = useOssixProviders({
    ActionType: ActionType.Transfer,
    CountryCode: userData?.[0]?.CountryCode,
    IncludeSelf: 'SELF',
    TargetType: TargetType.Bank,
  });

  useEffect(() => {
    if (secondAccountNumber && !loadingProviders) {
      const filteredProvider = providers?.find(
        (item: { ShortName: string }) => item.ShortName === 'AGB',
      );
      setSelectedProvider(filteredProvider);
    }
  }, [secondAccountNumber, loadingProviders]);

  useEffect(() => {
    if (contactAccount?.value) {
      const beneficiary = userContactData?.find(
        (item: { AccountNumber: any }) =>
          item.AccountNumber === contactAccount?.value,
      );
      setSelectedBeneficiary({
        ...beneficiary,
        ...beneficiary?.Operator,
      });

      setFormData((prev: any) => ({
        ...prev,
        ...{
          serviceNumber: contactAccount?.value,
          phoneNumber: contactAccount?.value,
        },
      }));
    }
  }, [contactAccount?.value]);

  return (
    <>
      {contextHolder}
      <BetweenOwnAccount
        isDrawerOpen={isDrawerOpen}
        form={form}
        step={step}
        onPrevious={onPrevious}
        userData={accountNumbers}
        handleCloseOpenDrawer={handleCloseOpenDrawer}
        loadingAccount={loadUserAccountNumbers}
        setAccountNumber={setAccountNumber}
        selectAccountNumber={selectAccountNumber}
        displaySelectContact={displaySelectContact}
        onHandleCloseSelectContact={onHandleCloseSelectContact}
        onHandleDisplaySelectContact={onHandleDisplaySelectContact}
        contactAccount={contactAccount}
        setContactAccount={setContactAccount}
        isLoadingContacts={isLoadingContacts}
        recipientAccountNumber={recipientAccountNumber}
        setSelectedProvider={setSelectedProvider}
        selectedProvider={selectedProvider}
        selectCountry={
          selectedBeneficiary?.CountryCode ||
          userData?.[0]?.CountryCode
        }
        dynamicFormItem={{
          contextHolder: contextHolder,
          onHandleValueChange: onHandleValueChange,
          onHandleTransferConfirmation:
            onHandleBankGatewayTransferConfirmation,
          loadTransferConfirmation: loadTransferConfirmation,
          transferConfirmationData: transferConfirmationData,
          onPINValuesChange: onPINValuesChange,
          onHandleConfirmTransfer: onHandleBankConfirmTransfer,
          loadSendFundsToGateway: loadSendFundsToGateway,
          openPrintTransaction,
          sendFundsToGatewayData,
          onHandleClosePrintPage,
          selectedBeneficiary,
          setSelectedBeneficiary,
          formData,
          selectedProvider,
          userData,
          onHandleSaveContact,
          accountNumber,
          secondAccountNumber,
          setSecondAccountNumber,
        }}
        showVerificationModal={showVerificationModal}
        verificationData={verificationData}
        handleVerificationComplete={handleVerificationComplete}
        handleVerificationCancel={handleVerificationCancel}
        loadTransferConfirmation={loadTransferConfirmation}
      />
    </>
  );
};

export default BetweenOwnAccountContainer;
